// v4 (V4-H2, spec-v4 5.1): where you are in the tree. Desktop shows the whole trail (Channel › Collection › Video);
// a phone shows only the way up ("‹ Milo & Friends"), which is what the old back link did.
import type { Crumb } from "../collections";
import { Link } from "../router";
import { Icon } from "./bits";

export function Crumbs({ items }: { items: Crumb[] }) {
  const up = [...items].reverse().find((c) => c.to);
  if (!items.length) return null;
  return (
    <nav className="crumbs" aria-label="You are here">
      {up?.to && (
        <Link to={up.to} className="back crumbs-up">
          <Icon name="back" size={18} /> {up.label}
        </Link>
      )}
      <ol className="crumbs-trail">
        {items.map((c, i) => (
          <li key={`${i}-${c.label}`}>
            {c.to ? (
              <Link to={c.to} className="crumbs-link">
                {c.label}
              </Link>
            ) : (
              <span className="crumbs-here" aria-current="page">
                {c.label}
              </span>
            )}
          </li>
        ))}
      </ol>
    </nav>
  );
}
